import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

import { ref, onMounted, computed } from "vue";
import IconChevron from "@/assets/icons/icon__chevron.svg";
import { useI18n } from "vue3-i18n";
import { useRouter } from "vue-router";
import { getChildPath } from "@/router/helpers";

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'Subnav',
  props: {
    routeKey: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "2b967249": (_unref(height))
}))

const props = __props;

const { t } = useI18n()
const router = useRouter();

const directChildRoutes = computed(() => {
  const routes = router.getRoutes();

  return routes.filter(r => r.path == t(`routes.${props.routeKey}.path`))[0].children;
})

let isExpanded = ref<boolean>(true);
let content = ref<HTMLElement>();
let height = ref<string>();

onMounted(() => {
  height.value = `${
    content.value != undefined ? content.value.scrollHeight : 0
    }px`;

    //close it once we have the scroll value
    toggleExpansion();
});

function toggleExpansion() {
  isExpanded.value = !isExpanded.value;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_ctx.routeKey)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["subnav", { 'subnav--expand': _unref(isExpanded) }])
      }, [
        _createElementVNode("button", {
          class: "subnav__title",
          onClick: toggleExpansion
        }, [
          _createTextVNode(_toDisplayString(_unref(t)(`routes.${_ctx.routeKey}.name`)) + " ", 1),
          _createVNode(_unref(IconChevron), {
            class: _normalizeClass(["icon icon--white", {'icon--rotate-180 icon--black' : !_unref(isExpanded)}])
          }, null, 8, ["class"])
        ]),
        _createVNode(_Transition, { name: "expand" }, {
          default: _withCtx(() => [
            (directChildRoutes.value != null && directChildRoutes.value.length > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("ul", {
                  key: 0,
                  class: "subnav__content",
                  ref_key: "content",
                  ref: content
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directChildRoutes.value, (child) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: child.name
                    }, [
                      _createVNode(_component_RouterLink, {
                        to: _unref(getChildPath)(_ctx.routeKey, child.name?.toString()),
                        class: "subnav__navlink"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)(`routes.${child.name?.toString()}.name`)), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ], 512)), [
                  [_vShow, _unref(isExpanded)]
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2))
    : _createCommentVNode("", true)
}
}

})